import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../../lib/api";
import errorMessage from "../../lib/errors";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("sz_admin_token", r.data.token);
      localStorage.setItem("sz_admin_user", JSON.stringify(r.data.user));
      toast.success("Welcome back");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(errorMessage(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5" style={{ background: "#f7faf6" }}>
      <div className="max-w-sm w-full">
        <Link to="/" className="block text-center mb-6">
          <img src="https://customer-assets.emergentagent.com/job_tech-dispatch-31/artifacts/a6ta9f48_SCREENZZ-LOGO-RGB_TextOnly.png"
            alt="ScreenzZ" className="h-10 mx-auto" />
        </Link>
        <div className="option-card">
          <h1 className="text-2xl font-bold mb-1">Admin login</h1>
          <p className="muted-text text-sm mb-5">Manage products and orders.</p>
          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider muted-text">Email</label>
              <input
                data-testid="admin-email"
                type="email" required
                className="rounded-input mt-1"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@screenzz.com"
              />
            </div>
            <div>
              <label className="text-xs font-semibold uppercase tracking-wider muted-text">Password</label>
              <input
                data-testid="admin-password"
                type="password" required
                className="rounded-input mt-1"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
            <button data-testid="admin-login-btn" className="cta-btn" disabled={busy}>
              {busy ? <span className="inline-flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Signing in</span> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
